import { render, staticRenderFns } from "./licenses_android.vue?vue&type=template&id=93585100&scoped=true"
import script from "./licenses_android.vue?vue&type=script&lang=js"
export * from "./licenses_android.vue?vue&type=script&lang=js"
import style0 from "./licenses_android.vue?vue&type=style&index=0&id=93585100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93585100",
  null
  
)

export default component.exports